<template>
  <div>
    <HomeIntro></HomeIntro>
    <ColumnLine></ColumnLine>
    <LatestNews class="home-page"></LatestNews>
    <AboutBlock></AboutBlock>
    <PlayersSlider></PlayersSlider>
    <BottomSection></BottomSection>
  </div>
</template>
<script>
const HomeIntro = () => import("@/components/homePage/HomeIntro");
const ColumnLine = () => import("@/components/homePage/ColumnLine");
const LatestNews = () => import("@/components/shared/Latest_news");
const AboutBlock = () => import("@/components/homePage/AboutBlock");
const PlayersSlider = () => import("@/components/homePage/PlayersSlider");
const BottomSection = () => import("@/components/shared/BottomSection");

const url = process.env.VUE_APP_URL;

export default {
  name: "home",
  components: {
    HomeIntro,
    ColumnLine,
    LatestNews,
    AboutBlock,
    PlayersSlider,
    BottomSection,
  },
};
</script>



